/**
 * Tipos del contrato HTTP entre el SDK y el backend.
 * Versión 1.
 *
 * IMPORTANTE: Si cambias algo aquí, debes actualizar también:
 * - veo-backend/src/modules/identity/dto/*.dto.ts
 * - veo-backend/src/modules/ingest/dto/*.dto.ts
 * - CONTRACT.md
 */

export const SDK_VERSION = '0.0.1';
export const MAX_BATCH_SIZE = 100;
export const DEFAULT_FLUSH_INTERVAL_MS = 5000;
export const DEFAULT_FLUSH_BATCH_SIZE = 20;

/**
 * Backend de Veo, horneado en el bundle. El consumidor NO configura la URL.
 * El valor se inyecta en build-time desde `VEO_API_URL` (ver tsup.config.ts);
 * el literal de aquí es solo el fallback para tests / builds sin esa env.
 * NO es secreta: va al bundle del navegador, igual que la `pk_`.
 */
export const DEFAULT_API_URL =
  process.env.VEO_API_URL || 'https://veo-backend-production-8c78.up.railway.app';

/**
 * Tipos de eventos que el SDK envía.
 * Debe coincidir con el CHECK constraint de veo_user_actions.action_type.
 */
export type ActionType = 'pageview' | 'track' | 'identify' | 'guide';

/**
 * Payload de un evento individual enviado al endpoint POST /v1/events.
 */
export interface ActionPayload {
  actionId: string; // UUID v7 generado en cliente
  endUserId: string;
  organizationId?: string;
  sessionId: string;
  actionType: ActionType;
  actionName?: string;
  occurredAt: string; // ISO 8601
  pageUrl?: string;
  pagePath?: string;
  pageTitle?: string;
  pageReferrer?: string;
  actionProperties?: Record<string, unknown>;
}

/**
 * Request del endpoint POST /v1/events.
 */
export interface IngestEventsRequest {
  events: ActionPayload[]; // máx 100
}

/**
 * Response del endpoint POST /v1/events.
 */
export interface IngestEventsResponse {
  accepted: number;
  deduped: number;
}

/**
 * Request del endpoint POST /v1/identify.
 */
export interface IdentifyRequest {
  endUser: {
    id: string;
    anonymousId?: string;
    traits?: Record<string, unknown>;
  };
  organization?: {
    id: string;
    attributes?: Record<string, unknown>;
  };
}

/**
 * Response del endpoint POST /v1/identify.
 */
export interface IdentifyResponse {
  endUserId: string;
  organizationId: string | null;
  workspaceId: string;
}

/**
 * Response de error estándar del backend.
 */
export interface ErrorResponse {
  error: string;
  details?: unknown;
  statusCode: number;
}
